var _defs, _path, _polygon, _polygon2, _path2, _path3, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrunk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326 74.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#009cdb;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.93,64.52H16a5.18,5.18,0,0,1-5.18-5.18V7.16A5.18,5.18,0,0,1,16,2h294a5.18,5.18,0,0,1,5.18,5.18V59.34A5.18,5.18,0,0,1,309.93,64.52Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.14 2.4 119.14 5.02 119.14 11.24 130.71 26.71 195.29 26.71 206.86 11.24 205.84 4.17 205.84 2.4 119.14 2.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.81 27.75 130.19 27.75 118.1 11.58 118.1 2.4 120.17 2.4 120.17 10.89 131.22 25.68 194.77 25.68 205.82 10.89 205.82 2.11 207.9 2.11 207.9 11.58 195.81 27.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.32,21.83h25.83c2.74,0,4.82-2.26,5.82-4.84l2.48-5.36a5,5,0,0,0-5-5h-57a5,5,0,0,0-5,5L132,17c1,2.58,3.08,4.84,5.81,4.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.15,22.86H137.84c-3.42,0-5.74-2.82-6.76-5.47l-2.57-5.54v-.22a6,6,0,0,1,6-6h57a6,6,0,0,1,6,6v.22l-2.57,5.54C193.89,20,191.58,22.86,188.15,22.86ZM130.59,11.41l2.41,5.2c.77,2,2.45,4.18,4.84,4.18h50.31c2.39,0,4.07-2.16,4.85-4.18l0-.06,2.38-5.14a3.94,3.94,0,0,0-3.93-3.72h-57A3.94,3.94,0,0,0,130.59,11.41Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 35,
    fill: "black",
    fontFamily: "OpenSans-Regular, Open Sans, sans-serif",
    fontSize: "9pt"
  }, "Trunk")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrunk);
export default __webpack_public_path__ + "static/media/trunk.964cdc3ec5caffe2d8d860b8c9f2c83a.svg";
export { ForwardRef as ReactComponent };